import $ from 'jquery';

export default class RTE {
  constructor(el) {
    this.el = el;
    this.$el = $(this.el);

    this.setupTabs();
    this.setupVideos();

    $(window).on('resize.rte', () => this.setupVideos());
    $('.tabs li').on('click.rte', this.switchTabs.bind(this));
  }

  setupVideos() {
    const videos = this.$el.not('.special').find('iframe, embed, object');
    const contentWidth = this.$el.width();

    for (let i = 0; i < videos.length; i++) {
      const $video = $(videos[i]);
      const aspectRatio = ($video.height() / $video.width());
      $video.css({
        width: contentWidth,
        height: contentWidth * aspectRatio,
      });
    }
  }

  switchTabs(e) {
    const tab = $(e.currentTarget, this.el);
    const tabContainer = tab.parent();
    const tabContentContainer = tabContainer.next();
    const position = tab.index();
    const content = tabContentContainer.find('> li').eq(position);

    tabContainer.find('> li').removeClass('active');
    tabContentContainer.find('> li').removeClass('active');

    tab.addClass('active');
    content.addClass('active');

    // We have to re-format videos exclusive to the tabs being opened
    // in the event that resizing occured while it was hidden.
    const videos = content.find('iframe, embed, object');
    const contentWidth = content.width();

    for (let i = 0; i < videos.length; i++) {
      const $video = $(videos[i]);
      const aspectRatio = ($video.height() / $video.width());
      $video.css({
        width: contentWidth,
        height: contentWidth * aspectRatio,
      });
    }
  }

  setupTabs() {
    const tabs = this.$el.find('.tabs');
    const tabsContent = this.$el.find('.tabs-content');

    if (this.$el.find(':first-child').hasClass('tabs')) {
      this.$el.parent().addClass('no-border');
    }

    tabs.find('li:first').addClass('active');
    return tabsContent.find('li:first').addClass('active');
  }

  unload() {
    $(window).off('resize.rte');
    $('.tabs li', this.el).off('click.rte');
  }
}
